import { FlatListProvider } from "@src/cloud-connect/node-manager/flat-list-provider";
import store from "@src/reducers/store";
import {
  emptyNodeDataObject,
  updateDeleteIconActiveState,
  updateNodeSelectionNodeData,
  updateNodeSelectionNodeEditedState,
  updateNodeSelectionState,
  updateShowBulkEditDataAcquisitionTypeIcon,
  updateStructureWasSaved,
} from "@src/reducers/your-reducer";
import { deleteNodes } from "./delete-nodes";
import { getLogger } from "../dependency-injection-container/get-logger";

const closePanelAndFlushNodeData = () => {
  store.dispatch(updateNodeSelectionNodeData(emptyNodeDataObject));
  store.dispatch(updateNodeSelectionNodeEditedState(false));
  store.dispatch(updateNodeSelectionState("none"));
};

export const deleteNodesFromNodeset = (
  transferedNodeData,
  filteredTransferedNodeData,
) => {
  const logger = getLogger();
  const t0 = performance.now();
  logger.debug("t0 - start of action", t0);

  deleteNodes(transferedNodeData, filteredTransferedNodeData);
  store.dispatch(updateDeleteIconActiveState(false));
  store.dispatch(updateShowBulkEditDataAcquisitionTypeIcon(false));
  closePanelAndFlushNodeData();
  store.dispatch(updateStructureWasSaved(false));
  FlatListProvider.getInstance().deleteFlatMachineStructureList();

  const t1 = performance.now();
  logger.debug("t1 - end of action", t1);
  logger.debug(`Action to delete node took ${t1 - t0} milliseconds.`);
};
